import { Injectable } from '@angular/core';
import {
  DataCollectionsControllerService,
  DataCollectionsWithRelations,
} from '@osos/shared/api';
import {
  IndexableLocalizedItem,
  LocalizedValueModel,
  Where,
} from '@osos/shared/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiUtilsService } from '../../api-utils/api-utils.service';

@Injectable()
export class CollectionDataService extends DataCollectionsControllerService {
  constructor(private apiHelper: ApiUtilsService) {
    super();
  }

  public getCollectionWithIdenticalNames(
    name: LocalizedValueModel,
    id?: string,
  ): Observable<IndexableLocalizedItem[]> {
    const localizedNameFilter: Where<DataCollectionsWithRelations> =
      this.apiHelper.prepareLocalPropFilter({
        name,
        id,
      });

    return this.findAll(
      this.apiHelper.prepareFilter({
        where: localizedNameFilter,
        fields: { id: true, name: true },
      }),
    ).pipe(map((collections) => collections as Array<IndexableLocalizedItem>));
  }
}
